import React from "react";
import "./AboutInfo.css";

const AboutInfo = () => {
  return (
    <div className="about-info-container">
      <div className="hl-0"></div>
      <div className="hl-1"></div>
      <div className="hl-2"></div>
      <div className="hl-3"></div>
      <div className="about-info-header">we turn dreams into realities.</div>
      <div className="about-info-para">
        Chawla Structural Design Engineers was founded by Engineer G.S. Chawla
        in the year of 2003. We have been striving for building the dreams of
        our clients. The design solutions so offered are economical , durable
        and practical. Engineer Atul Chawla, M.E. structures, postgraduate from
        the renowned Punjab Engineering College, is also a part of the
        consultancy firm. He has got experience of more than 28 years in this
        field and we are working with top architects. <br />
        <br />
        We offer structural design solutions for R.C.C as well as Steel
        residential, Commercial, Industrial buildings, Trusses, Concrete roads,
        Chimneys, bridges, hydraulic structures like Aqueducts, Syphons, Super
        Passages, Regulators, Water Tanks, Pipe Design etc. The structural
        designs are done by following the latest I.S. codes and computer aided
        design softwares. Specialised foundations like Machine foundations, Pile
        foundations, Well foundations have been designed in many of our projects
        and Retrofitting / Renovations of existing buildings have been carried
        out successfully.
      </div>
      <div className="about-our-services-header">
        OUR&nbsp;<span style={{ color: "#c5a47e" }}>SERVICES</span>
      </div>
      <div className="services-wrapper">
        <div className="service">
          <div className="service-header">
            <img
              src="https://7seven-miles.com/wp/go-arch/go-arch-light/wp-content/uploads/2011/05/icon-architecture.png"
              alt=""
            />
            <h4>HYDRAULIC STRUCTURES</h4>
          </div>
          <div className="service-content" style={{ textAlign: "justify" }}>
            Hydraulic structures involve Aqueducts, Cyphens, Super Passage,
            Regulators, etc. Design of bridges, culverts, are designed on canals
            and drains. We have designed the structural components of the
            hydraulic structure, including the type of materials to be used, the
            size and shape of the structure, and the reinforcement required to
            withstand the expected water pressures.
          </div>
        </div>
        <div className="service">
          <div className="service-header">
            <img
              src="https://7seven-miles.com/wp/go-arch/go-arch-light/wp-content/uploads/2011/05/icon-interiors.png"
              alt=""
            />
            <h4>MULTI STOREY BUILDINGS</h4>
          </div>
          <div className="service-content" style={{ textAlign: "justify" }}>
            Multi Storey buildings are typically designed for residential,
            commercial, or industrial purposes and are constructed with the use
            of steel, concrete, or wood frames. The construction of multi-storey
            buildings involves careful planning and consideration of factors
            such as foundation design, structural systems, building codes, and
            safety measures.
          </div>
        </div>
        <div className="service">
          <div className="service-header">
            <img
              src="https://7seven-miles.com/wp/go-arch/go-arch-light/wp-content/uploads/2011/05/icon-planing.png"
              alt=""
            />
            <h4>CONCRETE & BITUMINOUS ROADS</h4>
          </div>
          <div className="service-content" style={{ textAlign: "justify" }}>
            The design of concrete and bituminous roads is based on several
            factors, including traffic volume, climate, and soil conditions.
            Both types of roads also require careful consideration of factors
            such as drainage, slope, and curb and gutter design to ensure safe
            and effective traffic flow.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutInfo;
